export interface IChooseSenderStepModel {
    fullName: string;
}

export class ChooseSenderStepModel implements IChooseSenderStepModel {
    fullName: string;

    constructor() {
        this.fullName = "";
    }

    static isValid(model: IChooseSenderStepModel): boolean {
        if (!model.fullName || !model.fullName.trim()) {
            return false;
        }

        return true;
    }
}